import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { TwitterService } from './twitter.service';
import { TwitterLayoutComponent } from './twitter-layout.component';
import { TwitterBtnComponent } from './twitter-btn.component';
import { TwitterImgComponent } from './twitter-img.component';
import { TwitterCardComponent } from './twitter-card.component';


const routes: Routes = [
  { path: 'twitter',  component: TwitterLayoutComponent }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  declarations: [
    TwitterLayoutComponent,
    TwitterBtnComponent,
    TwitterImgComponent,
    TwitterCardComponent,
  ],
  exports: [
    RouterModule,
    TwitterLayoutComponent,
    TwitterBtnComponent,
    TwitterImgComponent,
    TwitterCardComponent,
  ],
  providers: [
    TwitterService
  ]
})
export class TwitterModule { }



// WEBPACK FOOTER //
// ./src/app/social/twitter/twitter.module.ts